module.exports = __webpack_public_path__ + "static/media/barn_complete.cfa1d329.png";